$(document).ready(function() {

    /* VR Slider rotation */
    var children = '';
    var slides = 0;
    var slideIprev = 0;
    var slideI = 0;
    var Autoplaytimer = 7000;
    var slidetimer = '';
    var transitiontime = 1000;

    //Slider Functions
    function initslider() {
        children = $("#slider .slide-inner").children();
        slides = children.length;
        slideI = 0;
        //first slide
        $(children[slideI]).addClass("active");
        //autoplay init
        autoplayslide();
        updatecount(slideI, slides);
    }

    function updateslide(slideIprev, slideI) {
        console.log("Previous Slide:" + slideIprev + " Next:" + slideI);

        //add fadeout animation
        $(children[slideIprev]).addClass("fadeout");
        //add fadein animation
        $(children[slideI]).addClass("fadein");

        //update active after transition
        setTimeout(function() {
            $("#slider .slide-inner>div").removeClass("active");
            $(children[slideI]).addClass("active");
        }, (transitiontime));

        //clean fades after transition
        setTimeout(function() {
            $("#slider .slide-inner>div").removeClass("fadeout fadein");
        }, (transitiontime));

        //Update Count
        updatecount(slideI, slides);
        autoplayreset();
    }

    function autoplayslide() {
        slidetimer = setTimeout(nextslide, Autoplaytimer);
    };

    function autoplayreset() {
        clearTimeout(slidetimer);
        autoplayslide();
    }

    function nextslide() {
        slideIprev = slideI;
        slideI++;
        if (slideI >= slides) { slideI = 0; };
        console.log("Next:" + slideI);
        updateslide(slideIprev, slideI);
    }

    function prevslide() {
        slideIprev = slideI;
        slideI = slideI - 1;
        if (slideI < 0) { slideI = (slides - 1); };
        console.log("Prev:" + slideI);
        updateslide(slideIprev, slideI);
    }

    function updatecount(slideI, slides) {
        //get slide text
        var slidenum = slideI + 1;
        var slidetext = $(children[slideI]).attr('data-text');
        //update text
        $(".slider-wrap .sl-count span").text(slidenum + ' / ' + slides);
        $(".slider-wrap .sl-count div").text(slidetext);
    }

    //Init Slider
    initslider();
    console.log("init slide");

    //Slider Actions
    $('#slider .next').click(function() {
        nextslide();
    });
    $('#slider .prev').click(function() {
        prevslide();
    });

    //Hammerjs Time for touch
    var myElement = document.getElementById('slider');
    var mc = new Hammer.Manager(myElement);
    mc.add(new Hammer.Pan({ direction: Hammer.DIRECTION_HORIZONTAL, threshold: 80, pointers: 0 }));

    mc.on("panleft panright", function(ev) {
        console.log(ev.type);
        switch (ev.type) {
            case "panleft":
                nextslide();
                break;
            case "panright":
                prevslide();
                break;
        }
        //Stops multiple events being triggered
        mc.stop();
    });

});